import { createSlice } from "@reduxjs/toolkit";
const initialState = { uuid: "", patient_name: "", patient_last_name: "" };

const planReducer = createSlice({
    name: "planReducer",
    initialState,
    reducers: {
        planState(state, action) {
            state.uuid = action.payload.uuid;
            state.patient_name = action.payload.patient_name;
            state.patient_last_name = action.payload?.patient_last_name || "";
        },
    },
});
export const { planState } = planReducer.actions;
export default planReducer.reducer;